import React from "react";
import "./Nav.css";

function Nav() {
  return (
    <div>
      <div className="nav__background">
        {" "}
        <div></div>
        <div className="Nav__footer">
          <div className="Nav__footer_item">All</div>
          <div className="Nav__footer_item">Clinic</div>
          <div className="Nav__footer_item">Customer Service</div>
          <div className="Nav__footer_item">Best Sellers</div>
          <div className="Nav__footer_item">Amazon Basics</div>
          <div className="Nav__footer_item">New Releases</div>
          <div className="Nav__footer_item">Prime</div>
          <div className="Nav__footer_item">Today's Deals</div>
          <div className="Nav__footer_item">Music</div>
          <div className="Nav__footer_item">Books</div>
          <div className="Nav__footer_item">Registry</div>
          <div className="Nav__footer_item">Fashion</div>
          <div className="Nav__footer_item">Amazon Home</div>
          <div>
            <div className="Nav__footer_item2">Shop Mother's Day</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
